import { render, staticRenderFns } from "./VxCardCustom.vue?vue&type=template&id=a0831cc8"
import script from "./VxCardCustom.vue?vue&type=script&lang=js"
export * from "./VxCardCustom.vue?vue&type=script&lang=js"
import style0 from "./VxCardCustom.vue?vue&type=style&index=0&id=a0831cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports